function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { createBreakpoints, createSpacing } from '@mui/system';
export default function adaptV4Theme(inputTheme) {
    if (process.env.NODE_ENV !== 'production') {
        console.warn([
            'MUI: adaptV4Theme() is deprecated.',
            'Follow the upgrade guide on https://mui.com/r/migration-v4#theme.'
        ].join('\n'));
    }
    var _inputTheme_defaultProps = inputTheme.defaultProps, defaultProps = _inputTheme_defaultProps === void 0 ? {} : _inputTheme_defaultProps, _inputTheme_mixins = inputTheme.mixins, mixins = _inputTheme_mixins === void 0 ? {} : _inputTheme_mixins, _inputTheme_overrides = inputTheme.overrides, overrides = _inputTheme_overrides === void 0 ? {} : _inputTheme_overrides, _inputTheme_palette = inputTheme.palette, palette = _inputTheme_palette === void 0 ? {} : _inputTheme_palette, _inputTheme_props = inputTheme.props, props = _inputTheme_props === void 0 ? {} : _inputTheme_props, _inputTheme_styleOverrides = inputTheme.styleOverrides, styleOverrides = _inputTheme_styleOverrides === void 0 ? {} : _inputTheme_styleOverrides, other = _object_without_properties(inputTheme, [
        "defaultProps",
        "mixins",
        "overrides",
        "palette",
        "props",
        "styleOverrides"
    ]);
    var theme = _object_spread_props(_object_spread({}, other), {
        components: {}
    });
    // default props
    Object.keys(defaultProps).forEach(function(component) {
        var componentValue = theme.components[component] || {};
        componentValue.defaultProps = defaultProps[component];
        theme.components[component] = componentValue;
    });
    Object.keys(props).forEach(function(component) {
        var componentValue = theme.components[component] || {};
        componentValue.defaultProps = props[component];
        theme.components[component] = componentValue;
    });
    // CSS overrides
    Object.keys(styleOverrides).forEach(function(component) {
        var componentValue = theme.components[component] || {};
        componentValue.styleOverrides = styleOverrides[component];
        theme.components[component] = componentValue;
    });
    Object.keys(overrides).forEach(function(component) {
        var componentValue = theme.components[component] || {};
        componentValue.styleOverrides = overrides[component];
        theme.components[component] = componentValue;
    });
    // theme.spacing
    theme.spacing = createSpacing(inputTheme.spacing);
    // theme.mixins.gutters
    var breakpoints = createBreakpoints(inputTheme.breakpoints || {});
    var spacing = theme.spacing;
    theme.mixins = _object_spread({
        gutters: function() {
            var styles = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return _object_spread_props(_object_spread({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles), _define_property({}, breakpoints.up('sm'), _object_spread({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up('sm')])));
        }
    }, mixins);
    var typeInput = palette.type, modeInput = palette.mode, paletteRest = _object_without_properties(palette, [
        "type",
        "mode"
    ]);
    var finalMode = modeInput || typeInput || 'light';
    theme.palette = _object_spread({
        // theme.palette.text.hint
        text: {
            hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
        },
        mode: finalMode,
        type: finalMode
    }, paletteRest);
    return theme;
}
